var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KAutocomplete',_vm._g(_vm._b({attrs:{"items":_vm.mappers,"item-text":"name","item-value":"id"}},'KAutocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }